module.exports = __webpack_public_path__ + "img/cabin_bag.f6a013d9.png";